// src/routes/playerRoutes.js
// Routes accessible to player user types

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

// Player user type page imports
import TeamRequests from "../pages/player/TeamRequests";
import MyTeam from "../pages/player/MyTeam";
import PlayerTeamManager from "../pages/player/PlayerTeamManager";
import Parents from "../pages/player/Parents";
import Events from "../pages/player/Events";
import EventDetail from "../pages/player/EventDetail";

/**
 * Player Access Protection Wrapper
 * Checks if user has the correct account type (player)
 */
const PlayerAccessRoute = ({ children }) => {
  const { user } = useAuth();

  // Check if user has correct account type
  const hasPlayerAccess = () => {
    if (!user?.accountType) {
      return false;
    }

    return user.accountType.toLowerCase() === 'player';
  };

  // If unauthorized account type, redirect to appropriate dashboard
  if (!hasPlayerAccess()) {
    console.log(
      `🚫 Access denied: Account type "${user?.accountType}" not authorized for player routes. Redirecting...`
    );
    
    // Redirect based on account type
    switch (user?.accountType?.toLowerCase()) {
      case 'organization':
        return <Navigate to="/organization/dashboard" replace />;
      case 'supervisor':
        return <Navigate to="/supervisor/dashboard" replace />;
      case 'parent':
        return <Navigate to="/parent/dashboard" replace />;
      case 'talent_scout':
        return <Navigate to="/talent-scout/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  // If authorized account type, allow access
  return children;
};

export const playerRoutes = [
  // Smart team management (shows team page if has team, otherwise team requests)
  {
    path: "/player/team-requests",
    element: (
      <PlayerAccessRoute>
        <PlayerTeamManager />
      </PlayerAccessRoute>
    ),
  },
  
  // Direct access to my team (for navigation purposes)
  {
    path: "/player/my-team",
    element: (
      <PlayerAccessRoute>
        <MyTeam />
      </PlayerAccessRoute>
    ),
  },
  
  // Direct access to team requests (for when leaving team, etc.)
  {
    path: "/player/team-search",
    element: (
      <PlayerAccessRoute>
        <TeamRequests />
      </PlayerAccessRoute>
    ),
  },
  
  // Parent management page
  {
    path: "/player/parents",
    element: (
      <PlayerAccessRoute>
        <Parents />
      </PlayerAccessRoute>
    ),
  },
  
  // Events page
  {
    path: "/player/events",
    element: (
      <PlayerAccessRoute>
        <Events />
      </PlayerAccessRoute>
    ),
  },
  {
    path: "/player/events/:eventId",
    element: (
      <PlayerAccessRoute>
        <EventDetail />
      </PlayerAccessRoute>
    ),
  },
  
  // TODO: Add more player-specific routes here when player pages are created
  // { path: "/player/dashboard", element: <PlayerAccessRoute><PlayerDashboard /></PlayerAccessRoute> },
  // { path: "/player/profile", element: <PlayerAccessRoute><PlayerProfile /></PlayerAccessRoute> },
  // { path: "/player/matches", element: <PlayerAccessRoute><PlayerMatches /></PlayerAccessRoute> },
  // { path: "/player/statistics", element: <PlayerAccessRoute><PlayerStatistics /></PlayerAccessRoute> },
]; 